module.exports = __webpack_public_path__ + "img/left.500690ad.png";